module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko_samples/cv_3_pc_d0497fc12d1924eaf6c93aac6863b84e.jpg";